export const FormTabsModes = {
  Required: 'Shows Required fields only',
  All: 'Shows All fields',
  Modified: 'Shows Modified fields only',
};
